import TextBlock from './blocks/TextBlock'
import HeadingBlock from './blocks/HeadingBlock'
import ImageBlock from './blocks/ImageBlock'
import ButtonBlock from './blocks/ButtonBlock'
import ColumnBlock from './blocks/ColumnBlock'
import MenuBlock from './blocks/MenuBlock'
import DividerBlock from './blocks/DividerBlock'
import SpacerBlock from './blocks/SpacerBlock'
import HTMLBlock from './blocks/HTMLBlock'
import SocialBlock from './blocks/SocialBlock'
import VideoBlock from './blocks/VideoBlock'
import TableBlock from './blocks/TableBlock'
import { useBuilder } from '../context/BuilderContext'

export default function BlockRenderer({ block }) {
  const { id, type, settings } = block
  const { updateBlock } = useBuilder()

  const handleInlineUpdate = (updates) => {
    updateBlock(id, updates)
  }

  switch (type) {
    case 'text':
      return <TextBlock settings={settings} onInlineUpdate={handleInlineUpdate} />
    case 'heading':
      return <HeadingBlock settings={settings} onInlineUpdate={handleInlineUpdate} />
    case 'image':
      return <ImageBlock settings={settings} onInlineUpdate={handleInlineUpdate} />
    case 'button':
      return <ButtonBlock settings={settings} />
    case 'columns':
      return <ColumnBlock settings={settings} blockId={id} />
    case 'menu':
      return <MenuBlock settings={settings} />
    case 'divider':
      return <DividerBlock settings={settings} />
    case 'spacer':
      return <SpacerBlock settings={settings} />
    case 'html':
      return <HTMLBlock settings={settings} />
    case 'social':
      return <SocialBlock settings={settings} />
    case 'video':
      return <VideoBlock settings={settings} />
    case 'table':
      return <TableBlock settings={settings} />
    default:
      return <div>Unknown block type: {type}</div>
  }
}
